// extracted by mini-css-extract-plugin
module.exports = {"text":"SelectUpdatePeriod_text__2AdlX"};